<template>
  <div>
    <SearchRecommendationDialog
      v-model="searchRecommendationDialog"
      :province="province"
    />
    <DialogInputServiceCharge
      :dialogInputServiceCharge="dialogInputServiceCharge"
      @cancel="cancelDialogPartner()"
      @save="saveDialogPartner($event)"
    />
    <newStoreForm
      :fetching_data="fetching_data"
      :store_data="store_data"
      :dialog="newStoreDialog"
      @setDialog="newStoreDialog = $event"
      @close="closeAdd()"
    />
    <div class="store-list-action-row">
      <div class="glass-action-group">
        <v-btn
          flat
          class="store-action store-action--recommendation"
          @click="searchRecommendationDialog = true"
        >
          <v-icon left>star</v-icon>
          Search Recommendations
        </v-btn>
        <v-btn
          v-if="!isEditStoreList"
          depressed
          color="#fddf00"
          class="store-action store-action--create"
          @click="toAdd()"
        >
          <v-icon left>add</v-icon>
          Create Store
        </v-btn>
      </div>
    </div>
    <v-layout row class="px-2">
      <v-flex xs12>
        <v-toolbar dense flat class="store-filter-bar py-1">
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            class="pa-0"
          ></v-text-field>

          <v-select
            v-model="storeActiveFilter"
            :items="storeActiveFilterOptions"
            label="Filter by Status"
            style="max-width: 200px; margin-left: 16px"
            hide-details
            single-line
            class="pa-0"
          ></v-select>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="filteredStoreList"
      class="elevation-1"
      :pagination.sync="pagination"
      :rows-per-page-items="[50, 100, 200, 500]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ countStore(props.item) }}</td>
        <td class="text-xs-center" style="color: #c6c6c6; font-weight: bold">
          {{ "#" + props.item.store_id }}
        </td>
        <td class="text-xs-center">
          <v-switch
            @change="deActivate($event, props.item)"
            v-model="props.item.store_active"
            :key="`switch-${props.item.store_id}-${props.item.store_active}`"
            color="primary"
            class="mt-2"
            style="max-width: 20px"
            :disabled="isEditStoreList"
            hide-details
          ></v-switch>
        </td>
        <td>
          <v-switch
            color="primary"
            @change="toChangeStatusPartner(props.item, $event)"
            v-model="props.item.store_partner"
            hide-details
          ></v-switch>
        </td>
        <td class="text-xs-left">{{ props.item.store_code }}</td>
        <td class="text-xs-left">{{ props.item.store_name_th }}</td>
        <td class="text-xs-left">
          <div v-if="props.item.store_email">
            <div
              v-for="(email, index) in props.item.store_email.split(',')"
              :key="index"
            >
              {{ email }}
            </div>
          </div>
        </td>
        <td class="text-xs-left">{{ groupStoreTel(props.item) }}</td>
        <td>
          <v-tooltip top>
            <v-btn icon @click="toGenerateLink(props.item)" slot="activator">
              <v-icon small>link</v-icon>
            </v-btn>
            <span>Get App Link</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon @click="toEdit(props.item)" slot="activator">
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :href="
                'https://weserve.co.th/store-preview/' +
                province +
                '/' +
                props.item.store_id
              "
              target="_blank"
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>Preview</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="store_list.length == 0 && loading_message == false">
          No data available
          <br />
          <v-btn @click="initialize()">Reset</v-btn>
        </div>

        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="storeLinkDialog" max-width="400px">
      <v-card>
        <v-card-title class="d-flex justify-space-between pb-0"
          ><div style="font-size: 20px; font-weight: bold">LINK GENERATOR</div>
          <div class="text-xs-right">
            <v-btn icon @click="storeLinkDialog = false"
              ><v-icon>close</v-icon></v-btn
            >
          </div>
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-text-field
              id="copyInput"
              label="Store link"
              v-model="linkGenerated"
              readonly
            ></v-text-field>
            <v-btn
              flat
              style="border: 1px solid black"
              @click="copyToClipboard()"
              >copy link</v-btn
            >
          </div></v-card-text
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import newStoreForm from "./NewStoreForm.vue";
import { mapState, mapGetters } from "vuex";
import DialogInputServiceCharge from "./DialogInputServiceCharge";
import SearchRecommendationDialog from "./SearchRecommendationDialog";
export default {
  data: () => ({
    linkGenerated: null,
    storeLinkDialog: false,
    selectStorePartner: {},
    dialogInputServiceCharge: false,
    fetching_data: false,
    search: "",
    loading_message: false,
    store_data: null,
    newStoreDialog: false,
    searchRecommendationDialog: false,
    pagination: {
      rowsPerPage: 50,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "store_count_temp",
      },
      {
        text: "Store ID",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Partner Store",
        align: "center",
        value: "store_partner",
        sortable: false,
      },
      {
        text: "Store Code",
        align: "center",
        sortable: false,
        value: "store_code",
      },
      {
        text: "Store Name",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Email",
        align: "center",
        value: "store_email",
        sortable: false,
      },
      {
        text: "Tel",
        align: "center",
        value: "store_tel_name_temp",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "store_active_name",
        sortable: false,
      },
    ],
    storeActiveFilter: null,
    storeActiveFilterOptions: [
      { text: "All", value: null },
      { text: "Active", value: true },
      { text: "Inactive", value: false },
    ],
  }),
  components: {
    newStoreForm,
    DialogInputServiceCharge,
    SearchRecommendationDialog,
  },
  computed: {
    ...mapState({
      store_detail_id: (state) => state.storeBack.store_detail_id,
      province: (state) => state.backOffice.province,
      store_list_pagination: (state) =>
        state.fetchStoreBack.store_list_pagination,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters({
      store_list: "fetchStoreBack/storeListTable",
      isEditStoreList: "isEditStoreList",
    }),
    filteredStoreList() {
      let filtered = this.store_list;
      if (this.storeActiveFilter !== null) {
        filtered = filtered.filter(
          (store) => store.store_active === this.storeActiveFilter
        );
      }
      return filtered;
    },
  },
  watch: {
    pagination() {
      this.$store.commit(
        "fetchStoreBack/setStoreListPagination",
        this.pagination
      );
    },
  },

  created() {
    this.initPageTable();
    this.initialize();
  },

  methods: {
    copyToClipboard() {
      const copyText = document.getElementById("copyInput");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      this.$toast.success("Link copied to clipboard!");
    },
    toGenerateLink(item) {
      const provinceID = this.provinceData.find(
        (val) =>
          val.province_name_en.replace(/ /g, "").toLowerCase() === this.province
      );
      this.storeLinkDialog = true;
      if (provinceID.province_id) {
        this.linkGenerated = `https://weserve.co.th/deeplink/?province=${provinceID.province_id}&service_type=0&action=goto_store&store_id=${item.store_id}`;
      }
    },
    saveDialogPartner(partner_service_charge) {
      this.dialogInputServiceCharge = false;
      this.updateStatus(partner_service_charge);
    },
    cancelDialogPartner() {
      this.dialogInputServiceCharge = false;
      this.selectStorePartner.store_partner =
        !this.selectStorePartner.store_partner;
      this.selectStorePartner = {};
    },
    async toChangeStatusPartner(item, value) {
      this.selectStorePartner = item;
      if (value == false) {
        this.dialogInputServiceCharge = true;
      } else {
        this.updateStatus();
      }
    },
    async updateStatus(service_charge) {
      let form = {
        store_id: this.selectStorePartner.store_id,
        store_partner: this.selectStorePartner.store_partner,
        store_partner_service_charge: 0,
      };
      if (service_charge) {
        form.store_partner_service_charge = service_charge;
      }
      let result = await this.$store.dispatch(
        "fetchStoreBack/changeStatusStorePartner",
        form
      );
      if (result == false) {
        this.selectStorePartner.store_partner =
          !this.selectStorePartner.store_partner;
      }
      this.selectStorePartner = {};
    },
    initPageTable() {
      this.pagination = this.store_list_pagination;
    },
    countStore(item) {
      const index = this.filteredStoreList.indexOf(item) + 1;
      item.store_count_temp = index;
      return index;
    },
    groupStoreTel(item) {
      return item.store_tel_name_temp;
    },
    async ChangeFreeDelivery(item) {
      let clone_item = JSON.parse(JSON.stringify(item));
      let send_data = {
        store_id: clone_item.store_id,
        store_free_delivery: clone_item.store_free_delivery,
      };
      const check_success = await this.$store.dispatch(
        "fetchStoreBack/changeFreeDeliveryStatus",
        send_data
      );
      if (check_success != true) {
        item.store_free_delivery = !item.store_free_delivery;
      }
    },
    storeActive(item) {
      if (item.store_active == 0) {
        item.store_active_name = "Inactive";
      } else {
        item.store_active_name = "Active";
      }
      return item.store_active_name;
    },
    async toEdit(item) {
      this.$store.commit("storeBack/setStoreName", item.store_name_th);
      this.$store.commit("storeBack/setStoreDetailId", item.store_id);
      this.$store.commit("backOffice/changeLoadingProgress", false);
      this.$router.push({
        path:
          "/weserve_admin_login/control/" +
          this.$store.state.backOffice.province +
          "/storeandproduct/store/" +
          item.store_id +
          "/storeinfo",
      });
    },
    closeAdd() {
      this.setFormStore();
      this.newStoreDialog = false;
    },
    async initialize() {
      this.loading_message = true;
      try {
        const check = await this.$store.dispatch("fetchStoreBack/getStoreList");
        if (check === 3) {
          this.$store.commit("fetchStoreBack/getStoreList", []);
        }
        await Promise.all([
          this.$store.dispatch("fetchStoreBack/getDataType"),
          this.$store.dispatch(
            "fetchPackageBack/getData",
            this.$route.params.province
          ),
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
      } finally {
        this.loading_message = false;
      }
    },
    async deActivate(value, row_item) {
      const item = { ...row_item };
      delete item.store_active_name;

      const check_success = await this.$store.dispatch(
        "fetchStoreBack/deActivateStoreList",
        { item, value }
      );

      if (check_success === 3) {
        row_item.store_active = !value;
      }
    },
    setFormStore() {
      this.store_data = {
        store_user_id: null,
        store_use_pos: 0,
        store_image: null,
        store_type: [],
        store_name_th: null,
        store_description_th: null,
        store_name_en: null,
        store_description_en: null,
        store_name_cn: null,
        store_description_cn: null,
        store_lat: null,
        store_long: null,
        store_vat: null,
        store_service_charge: null,
        store_country_tel: "+66",
        store_tel: [{ tel: "" }],
        store_email: [{ email: "" }],
        store_package_id: null,
        store_price_range_start: null,
        store_price_range_end: null,
        store_active: false,
        store_store_service_id: null,
        store_address_th: null,
        store_address_en: null,
        store_address_cn: null,
        store_district_id: null,
        store_province_id: null,
        store_sub_district_id: null,
        store_zipcode_id: null,
        store_time: {
          store_time_open_mon: null,
          store_time_open_tue: null,
          store_time_open_wed: null,
          store_time_open_thu: null,
          store_time_open_fri: null,
          store_time_open_sat: null,
          store_time_open_sun: null,
          store_time_close_mon: null,
          store_time_close_tue: null,
          store_time_close_wed: null,
          store_time_close_thu: null,
          store_time_close_fri: null,
          store_time_close_sat: null,
          store_time_close_sun: null,
          store_time_open_mon2: null,
          store_time_open_tue2: null,
          store_time_open_wed2: null,
          store_time_open_thu2: null,
          store_time_open_fri2: null,
          store_time_open_sat2: null,
          store_time_open_sun2: null,
          store_time_close_mon2: null,
          store_time_close_tue2: null,
          store_time_close_wed2: null,
          store_time_close_thu2: null,
          store_time_close_fri2: null,
          store_time_close_sat2: null,
          store_time_close_sun2: null,
        },
      };
    },
    async toAdd() {
      this.setFormStore();
      this.newStoreDialog = true;
      this.fetching_data = true;
      try {
        await this.$store.dispatch("fetchProvinceBack/getProvinceList");
      } finally {
        this.fetching_data = false;
      }
    },
  },
};
</script>

<style scoped>
.store-list-action-row {
  display: flex;
  justify-content: flex-end;
  margin: 0 0 16px;
}

.glass-action-group {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.78),
    rgba(255, 255, 255, 0.48)
  );
  box-shadow: 0 10px 30px rgba(44, 62, 80, 0.12);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.store-action {
  min-height: 42px;
  margin: 0;
  border-radius: 11px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}

.store-action--recommendation {
  border: 1px solid rgba(117, 117, 117, 0.16);
  background: rgba(255, 255, 255, 0.72) !important;
  color: #37474f !important;
}

.store-action--create {
  color: #263238 !important;
  box-shadow: 0 6px 16px rgba(253, 223, 0, 0.28) !important;
}

.store-filter-bar {
  border: 1px solid rgba(207, 216, 220, 0.7);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.76) !important;
  box-shadow: 0 6px 20px rgba(44, 62, 80, 0.07);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

@media (max-width: 600px) {
  .glass-action-group {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .store-action {
    width: 100%;
  }
}
</style>
